import { render, staticRenderFns } from "./MewIconButton.vue?vue&type=template&id=30db31e8&scoped=true"
import script from "./MewIconButton.vue?vue&type=script&lang=js"
export * from "./MewIconButton.vue?vue&type=script&lang=js"
import style0 from "./MewIconButton.vue?vue&type=style&index=0&id=30db31e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db31e8",
  null
  
)

export default component.exports